import PropTypes from "prop-types";
import { FilterList } from "./FilterList";
import { TYPE, SIZE, COLOUR_TAGS, CATEGORY } from "./constants";
import styles from "./styles/FilterDropdown.module.css"

export const FilterDropdown = ({
  filterName,
  filterLabels,
  filteredValues,
  onChange,
  showPanel,
  searchView = false
}) => {

  const activeFilters = [CATEGORY, TYPE, COLOUR_TAGS, SIZE];

  const containerStyles = `
    ${searchView ? styles.openContainer : styles.container}
    ${showPanel ? styles.showContainer : ""}
  `;
  return (
    <div className={containerStyles}>
      {filterLabels && activeFilters.map((filter) => {
        return (
          <div key={filter}>
            {filterName === filter && (
              <FilterList
                filterName={filter}
                filterLabels={[...filterLabels]}
                filteredValues={filteredValues}
                onChange={onChange}
                searchView={searchView}
              />
            )}
          </div>
        )
      })}
    </div>
  );
};

FilterDropdown.propTypes = {
  filterName: PropTypes.string,
  filterLabels: PropTypes.object,
  filteredValues: PropTypes.array,
  onChange: PropTypes.func,
  showPanel: PropTypes.bool,
};
